import React from "react";
import styled from "styled-components";

const colors = { enabled: "#16865c", disabled: "#d05252", restricted: "#b6811b", unknown: "#87919c" };
const labels = { enabled: "Enabled", disabled: "Disabled", restricted: "Restricted", unknown: "Status unavailable" };
const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 9px;
  border-radius: 20px;
  border: 1px solid ${props => colors[props.status] || colors.unknown};
  color: var(--text-color);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  &::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${props => colors[props.status] || colors.unknown};
  }
`;
const Detail = styled.div`
  font-size: 13px;
  line-height: 1.5;
  margin-top: 8px;
  ul { margin: 6px 0; padding-left: 20px; }
  li { margin-top: 4px; }
`;

export const StatusBadge = ({ status = "unknown", children }) =>
  <Badge status={status}>{children || labels[status] || labels.unknown}</Badge>;

export default function DeliveryStatus({ delivery }) {
  if (!delivery) return <StatusBadge />;
  return (
    <Detail>
      <strong>Delivery:</strong> {delivery.reason}
      {delivery.restrictions && delivery.restrictions.length > 0 && (
        <ul>{delivery.restrictions.map(text => <li key={text}>{text}</li>)}</ul>
      )}
    </Detail>
  );
}
